import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	business: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.type.business',
		defaultMessage: 'Business',
		description:
			'Table cell content displayed in the projects directory type column for business projects. Word " project" will be appended to the end of this string in UI.',
	},
	productDiscovery: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.type.product-discovery',
		defaultMessage: 'Product discovery',
		description:
			'Table cell content displayed in the projects directory type column for polaris/discovery projects. Word " project" will be appended to the end of this string in UI.',
	},
	// rebrand
	companyManagedBusiness: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.type.company-managed-business',
		defaultMessage: 'Company-managed business',
		description:
			'Table cell content displayed in the projects directory type column for classic business projects. Word " project" will be appended to the end of this string in UI.',
	},
	companyManagedServiceProject: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.type.company-managed-service-project',
		defaultMessage: 'Company-managed service project',
		description:
			'Table cell content displayed in the projects directory type column for classic service projects. Word " project" will be appended to the end of this string in UI.',
	},
	teamManagedServiceProject: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.type.team-managed-service-project',
		defaultMessage: 'Team-managed service project',
		description:
			'Table cell content displayed in the projects directory type column for next-gen service projects. Word " project" will be appended to the end of this string in UI.',
	},
	companyManagedSoftware: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.type.company-managed-software',
		defaultMessage: 'Company-managed software',
		description:
			'Table cell content displayed in the projects directory type column for classic software projects. Word " project" will be appended to the end of this string in UI.',
	},
	teamManagedSoftware: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.type.team-managed-software',
		defaultMessage: 'Team-managed software',
		description:
			'Table cell content displayed in the projects directory type column for next-gen software projects. Word " project" will be appended to the end of this string in UI.',
	},
});
